export function PageHeader({ eyebrow, title, subtitle, actions }) {
  return (
    <div className="mb-6 sm:mb-8 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
      <div className="min-w-0">
        {eyebrow ? (
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-cyan-300/80 mb-2">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-50">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-2 text-sm sm:text-base text-slate-400 max-w-2xl">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ? <div className="flex gap-2 shrink-0">{actions}</div> : null}
    </div>
  );
}
